import React from "react";
import Testimonials from "../home/Testimonials";

const B2BDataTestimonials = () => {
  return <Testimonials />;
};

export default B2BDataTestimonials;
